export default __webpack_public_path__ + "static/media/todo.dcb8a7b2.jpg";